export default "__VITE_ASSET__Dq$GM31___"